var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeonixBlanco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207.01 79.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Identidad_corporativa",
    "data-name": "Identidad corporativa"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.91,23.31l-5.35,6.52-1.25-.65c-.21-.11-.34-.3-.38-.53l-.67-4,2.38-.75c.14-.04.26-.13.35-.23l2.18-2.61-4.17.27c-.08,0-.15.03-.22.06l-1.93,1.02c-.3.16-.48.46-.48.8v8.31c0,.83-.67,1.5-1.5,1.5h-4.36c-.83,0-1.5-.67-1.5-1.5v-8.31c0-.34-.18-.64-.48-.8l-1.93-1.02c-.06-.03-.14-.06-.22-.06l-4.17-.27,2.18,2.61c.09.11.21.19.35.23l2.38.75-.67,4c-.04.22-.18.42-.38.53l-1.25.65-5.35-6.52c-.1-.13-.12-.3-.05-.44l4.62-8.9h4.16l4.47,4.56,4.45-4.56h4.04l4.81,8.9c.07.14.06.31-.05.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.54,39.3c-.72.27-1.29.45-1.9.64-.51.16-1.28.19-1.77-.03-1.13-.53-1.68-1.65-1.94-2.34-.14-.38-.16-.8-.04-1.19l2.29-7.29s.02-.02.03,0c.33,1.19.44,1.68.48,2.5.02.35,0,.71-.02,1.06-.03.37-.03.98.18,1.43.32.64,1.45.66,2.75,1.43.51.3.93.75,1.13,1.31,0,0,0,.01,0,.02.36,1-.19,2.09-1.2,2.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.91,39.3c.72.27,1.29.45,1.9.64.51.16,1.28.19,1.77-.03,1.13-.53,1.68-1.65,1.94-2.34.14-.38.16-.8.04-1.19l-2.29-7.29s-.02-.02-.03,0c-.33,1.19-.44,1.68-.48,2.5-.02.35,0,.71.02,1.06.03.37.03.98-.18,1.43-.32.64-1.45.66-2.75,1.43-.51.3-.93.75-1.13,1.31,0,0,0,.01,0,.02-.36,1,.19,2.09,1.2,2.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.7,1.69c4.16-1.62,8.87-.85,12.23,2.02,3.55,3.04,5.02,7.92,3.74,12.47-.04-.95-.35-6.78-5.3-10.97-4.46-3.78-9.57-3.58-10.66-3.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.01,7.27c4.55-3.98,10.89-5,16.1-2.58,6.39,2.96,7.92,9.62,8.09,10.4-.86-1.46-3.68-5.82-9.35-8.1-7.2-2.89-13.59-.26-14.84.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.02,7.89c-.31.25-.59.59-.84,1.05-.17.31-.33.66-.48,1.08-2.15-.06-4.56.18-7.1.98-6.4,2.01-9.98,6.36-11.18,7.98.26-.79,2.81-8.21,10.59-10.76,2.95-.97,6.06-1.04,9.01-.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.3,17.9s-.02,0-.03,0c-2.77.64-7.3,2.5-11.76,6.71-5.93,5.61-7.41,12.3-7.8,14.56-.02-1.81.13-9.86,6.41-16.76,4.13-4.53,8.67-6.71,12.11-7.57.03,0,.05-.02.07-.02.02.19.04.4.07.62.02.14.05.29.09.45.21.84.48,1.44.76,1.89.02.04.05.07.07.11h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.75,17.9l-.65-1.71c-.17-.44-.29-.9-.37-1.36-.14-.88-.12-1.78.1-2.65.22-.87.46-1.54.74-2.04.35-.64.76-1.01,1.25-1.19.48-.17,1.02-.11,1.49.11,1.37.66,2.67,1.5,3.85,2.52.08.07.16.14.24.21.03.03.06.06.09.08,0,0,0,0,0,0,.03.03.06.05.08.08.06.05.12.11.18.17h0s-1.59.62-2.67-.11c-2.06-.97-3.3-.22-3.8,1.16-.19.55-.19.94-.16,1.41.05.68.25,1.24.38,1.59l-.78,1.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.12,19.9c-.96.28-12.56,3.89-16.1,15.42-2.41,7.87.29,14.56,1.12,16.36-.45-3.04-.72-8.7,1.54-15.16,3.48-9.93,10.93-15.05,13.43-16.62h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.33,25.99c-1.89.92-4.41,2.41-6.97,4.75-2.76,2.54-4.54,5.14-5.63,7.04.58-2.09,1.72-5.24,4.08-8.53,2.57-3.58,5.48-5.78,7.37-6.99l-.3,1.93.02.02,1.43,1.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.31,11.77s-.08.03-.11.05c-3.19,1.42-5.88,2.23-11.86,7.7-3.28,3-5.99,7.34-7.33,9.88.15-1.75.83-7.02,5.05-11.64,5.35-5.84,12.55-5.95,14.15-5.99h.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.22,10.01c-.26-.73-1.78-4.78-4.78-5.41-3.5-.74-8.65,3.28-10.03,10.77,2.89-6.22,7.9-9.34,11.41-8.28.66.2,2.1.79,3.4,2.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.54,17.9l.65-1.71c.17-.44.29-.9.37-1.36.14-.88.12-1.78-.1-2.65-.22-.87-.46-1.54-.74-2.04-.35-.64-.76-1.01-1.25-1.19-.48-.17-1.02-.11-1.49.11-1.37.66-2.67,1.5-3.85,2.52-.08.07-.16.14-.24.21-.03.03-.06.06-.09.08,0,0,0,0,0,0-.03.03-.06.05-.08.08-.06.05-.12.11-.18.17h0s1.59.62,2.67-.11c2.06-.97,3.3-.22,3.8,1.16.19.55.19.94.16,1.41-.05.68-.25,1.24-.38,1.59l.78,1.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.88,2.58c-3.04-1.58-6.73-1.11-9.2,1.14-2.26,2.07-3.08,4.48-2.47,8.14.17-.95,1.11-3.96,4.01-6.47,3.17-2.75,6.77-2.82,7.67-2.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.14.27c2.22-.71,4.65-.02,6.13,1.73,1.37,1.62,1.71,3.9.89,5.89-.13-.87-.52-2.61-1.83-4.3-1.87-2.41-4.38-3.13-5.19-3.32h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.04,
    y1: 61.12,
    x2: 9.01,
    y2: 55.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.43,
    y1: 77.33,
    x2: 27.4,
    y2: 72.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.23,
    y1: 69.22,
    x2: 18.2,
    y2: 63.91
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.04 40.94 15.04 61.12 9.01 55.81 9.01 40.94 15.04 40.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.23 36.67 24.23 69.22 18.2 63.91 18.2 30.02 18.71 30.02 24.23 36.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.87,49.52v27.8l-6.03-5.31v-28.02c.24.49.52,1.08,1.06,1.6.94.91,1.16,1.1,1.85,1.62.3.22.61.46.92.71,1.02.83,1.92,1.43,1.93,1.44l.05.03c.07.05.15.09.23.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.63,43.99v29.74l-6.03,5.31v-29.52c.08-.04.15-.08.22-.14l.05-.03s.91-.61,1.93-1.44c.3-.25.61-.48.92-.71.69-.51.59-.39,1.53-1.3.53-.52,1.14-1.43,1.39-1.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.66,39.92l-1.9.88c-.68.29-1.47.59-2.24.78-.35.09-.69.15-1.01.19,0,0-.03.85,1.01,2.1.48.58,1.42,1.16,2.4,1.96.91.74,1.73,1.29,1.73,1.29,0,0,.76-.55,1.68-1.29.98-.8,1.92-1.38,2.4-1.96,1.05-1.25,1.01-2.1,1.01-2.1-.33-.03-.67-.1-1.01-.19-.77-.19-1.56-.49-2.24-.78-.56-.24-1.04-.47-1.38-.64-.21-.11-.37-.19-.45-.24h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.85,63.21h-16.42c-5.54,0-8.23-2.68-8.23-8.1v-23.35h7.34v22.77c0,2.06.76,2.73,3.09,2.73h11.5c1.34,0,1.97.54,2.15,1.79l.58,4.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.14,47.96c0-6.29,3.51-9.62,10.98-9.62h2.51c7.48,0,11.03,3.33,11.03,9.62v3.37c0,1.32-.64,1.96-2.05,1.96h-15.5v.41c0,2.6,1.23,3.69,4.19,3.69h10.62c1.32,0,1.96.55,2.14,1.82l.55,3.97h-13.49c-7.52,0-10.98-3.19-10.98-9.43v-5.79h0ZM95.83,48.46v-.6c0-2.69-1.14-3.74-4.28-3.74h-2.14c-3.15,0-4.28,1.05-4.28,3.74v.6h10.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.02,53.98c0,5.95-3.4,9.21-10.34,9.21h-5.32c-6.93,0-10.33-3.26-10.33-9.21v-6.35c0-5.95,3.4-9.21,10.33-9.21h5.32c6.93,0,10.34,3.26,10.34,9.21v6.35ZM114.1,53.62c0,2.68,1.25,3.85,4.25,3.85h3.35c3,0,4.25-1.16,4.25-3.85v-5.64c0-2.68-1.25-3.85-4.25-3.85h-3.35c-3,0-4.25,1.16-4.25,3.85v5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.45,38.35h4.07c1.12,0,1.52.27,1.84,1.16l.45,1.9h.18c1.07-1.93,3.31-3,6.35-3h2.28c6,0,8.68,3.44,8.68,9.21v15.63h-7.07v-15.36c0-2.68-1.07-3.8-4.07-3.8h-1.57c-3,0-4.07,1.12-4.07,3.8v15.36h-7.07v-24.91h0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 165.7,
    y: 38.35,
    width: 7.07,
    height: 24.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.15,63.2l9.92-12.24c.37-.46.32-.51,0-.93l-9.9-11.69h8.1c1.48,0,2.04.23,2.78,1.25l4.13,6.49h.23l4.13-6.49c.74-1.02,1.3-1.25,2.78-1.25h7.7l-9.92,11.54c-.32.46-.37.42,0,.83l9.92,12.47h-7.46c-1.39,0-1.6-.28-2.35-1.25l-4.77-7.23h-.23l-4.82,7.23c-.74.97-1.83,1.25-3.22,1.25h-7.01,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 165.7,
    y: 31.75,
    width: 7.09,
    height: 4.41
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeonixBlanco);
export default __webpack_public_path__ + "static/media/leonix_blanco.b9054c43ce1bbc85ac521b21afd10654.svg";
export { ForwardRef as ReactComponent };